<template>
  <div>
    <div class="grid grid-cols-3 gap-4 my-5 text-center text-sm font-medium w-[50%]">
      <div>
        <button @click="openNotePopup('Thêm phiếu thu định kỳ')" class="py-1 w-[100%] border-2 border-gray-200 rounded-md text-gray-500 hover:text-[#1865b1] hover:border-[#1865b1]"><font-awesome-icon :icon="['fas', 'plus']" /> Thêm mới</button>
      </div>
      <div>
        <button class="py-1 w-[100%] border-2 border-blue-200 rounded-md text-[#1865b1] bg-blue-100 hover:bg-[#1865b1] hover:text-white hover:border-[#1865b1]"><font-awesome-icon :icon="['fas', 'copy']" /> Khoản thu chi định
          kỳ</button>
      </div>
      <div>
        <button @click="reloadPage()" class="py-1 w-[100%] border-2 border-green-200 rounded-md text-green-500 bg-green-100 hover:text-white hover:bg-green-500 hover:border-green-500"><font-awesome-icon :icon="['fas', 'rotate-right']" /> Tải lại</button>
      </div>
    </div>
    <TablePaymentcomponent :tablepaymentHeader="tableHeader" />
    <NotePeriodicpopup v-if="isShowNotePopup" :isShow="isShowNotePopup" @closed="isShowNotePopup = false" :nameHeader="titlePopup"/>
  </div>
</template>

<script>
import TablePaymentcomponent from '../component/TablePaymentcomponent.vue';
import NotePeriodicpopup from '../popup/NotePeriodicpopup.vue';
export default {
  components: {
    TablePaymentcomponent,
    NotePeriodicpopup
  },
  data() {
    return {
      tableHeader: ["Mã phiếu", "Loại phiếu", "Nhóm thu chi", "Phương thức", "Tổng tiền", "Trạng thái", "Hạch toán", "Thời gian", "Chu kỳ tiếp theo"],
      isShowNotePopup: false
    };
  },
  methods: {
    openNotePopup(value) {
      this.isShowNotePopup = true
      this.titlePopup = value
    },
    reloadPage() {
      window.location.reload();
    }
  },
};
</script>

<style scoped></style>